import IntegrasiModule from "../../../../../components/categories/superadmin/privilege/integrasi_module/Home"

export default function Home() {  
  return (
    <IntegrasiModule />
  );
}
